<script>
    // @ts-nocheck

    export let value = null
    export let label = null
    export let required = false
    export let disabled = false
    export let validation = null
    export let errorMsg = null
    export let name = null
    export let display = false
    export let valid = null
    export let placeholder = ''
    export let info = null
    import { Typography } from '.'
    import { getContext } from 'svelte'
    import { CalendarOutline, InfoOutline } from '../Icons'
    import DatePicker from './DatePicker.svelte'
    import { createEventDispatcher } from 'svelte'
    import { clickOutside, Datetime, getCSSVar } from '$lib/utils'
    let currentDate = new Datetime()
    let date = currentDate
    let focus
    const dispatch = createEventDispatcher()
    function onchange() {
        dispatch('change', {})
    }
    function onkeypress() {
        dispatch('keypress', {})
    }
    function onkeyup() {
        dispatch('keyup', {})
    }
    function onblur() {
        dispatch('blur', {})
    }
    let togglePicker = false
    let formData = getContext('formData')
    $: if (((value && name) || name) && formData)
        formData.update((x) => {
            return Object.assign(x, Object.fromEntries([[name, value]]))
        })
    $: if (displayName && [2, 5].includes(displayName.length)) {
        if (displayName.at(-1) !== '/') {
            displayName += '/'
        }
    }
    // $: console.log(currentDate);
    $: currentDate = date
    $: displayName = value ? value.split('-').reverse().join('/') : ''
    // $: console.log(displayName);
    $: valid = validation && value ? validation(value) : true
</script>

<div
    on:focus={(_) => (focus = true)}
    on:blur={(_) => (focus = false)}
    use:clickOutside
    on:clickout={(_) => (togglePicker = false)}
    class="box"
    class:disabled
>
    {#if label}
        <div
            style="position: relative; display: flex; gap: 7px; align-items: center; margin-bottom: 16px"
        >
            <Typography
                style="margin: 0 0 0 0;"
                type="caption"
                color={disabled ? 'grey-300' : 'black'}>{label}</Typography
            >
            {#if required && !disabled && !value}
                <InfoOutline size={16} />
            {/if}
        </div>
    {/if}
    <div
        style="position: relative; display: flex; gap: 12px; justify-content: space-between; align-items: center; width: 100%"
    >
        <input
            type="text"
            on:change={onchange}
            on:focus={(_) => {
                togglePicker = true
                focus = true
            }}
            on:keypress={onkeypress}
            on:keyup={(e) => {
                if (
                    e.target.value.match(
                        /[0-9]{2}\/[0-9]{2}\/(19|20)[0-9]{2}$/g
                    )
                ) {
                    date = new Datetime(
                        ...displayName
                            .split('/')
                            .reverse()
                            .map((x, i) => {
                                return parseInt(i == 1 ? x - 1 : x)
                            })
                    )
                } else {
                    console.log(e.target.value)
                }
                onkeyup()
            }}
            on:blur={(_) => {
                onblur()
                focus = false
            }}
            {disabled}
            {placeholder}
            bind:value={displayName}
        />
        <i
            style="cursor: pointer"
            on:click={(_) => (togglePicker = !togglePicker)}
            ><CalendarOutline
                color={getCSSVar('--color-brand-primary-01')}
            /></i
        >
    </div>
    <span
        class={`${!valid && validation && value && !disabled ? 'error' : ''} ${focus ? 'focus' : ''}`}
        style={(!valid && errorMsg && !disabled) || info
            ? 'padding: 11px 0;'
            : ''}
    >
        {#if value && validation && !valid && errorMsg && !disabled}
            <Typography type="label" style="margin: 0">{errorMsg}</Typography>
        {:else if info && !disabled}
            <Typography type="caption" color="grey-300" style="margin: 0"
                >{info}</Typography
            >
        {/if}
        {#if togglePicker}
            <div class="hiddenBox">
                <DatePicker
                    {display}
                    bind:date
                    bind:value
                    {currentDate}
                    on:select={(_) => (togglePicker = false)}
                    on:close={(_) => (togglePicker = false)}
                />
            </div>
        {/if}
    </span>
</div>

<style>
    .hiddenBox {
        position: absolute;
        z-index: 9;
    }
    .box {
        width: 100%;
        padding: 10px 0;
        display: flex;
        flex-direction: column;
        user-select: none;
    }
    input[type='text'] {
        background: transparent;
        padding: 0 0 11px 0;
        border-style: none;
        margin: 0;
        font-size: 17px;
        width: 90%;
        line-height: 22px;
        color: var(--color-black);
        outline: none;
        caret-color: #5496e3;
    }
    input[type='text']::placeholder {
        color: var(--color-grey-300);
    }
    input[type='text']:disabled {
        cursor: no-drop;
    }
    span {
        width: 100%;
        border-top: 1px var(--color-grey-300) solid;
        display: flex;
    }

    span.focus {
        border-top: 1px var(--color-grey-800) solid;
    }

    .error {
        border-top: 1px var(--color-accent-alert-error) solid;
        color: var(--color-accent-alert-error);
        background: var(--color-accent-alert-error-bg);
    }

    .disabled {
        cursor: no-drop;
    }

    .disabled span {
        border-top: 1px var(--color-grey-300) solid;
    }

    .disabled input[type='text']:disabled {
        color: var(--color-grey-400);
    }
</style>
